import { TourConfig } from '../services/tour-guide.service';

export const RETURNS_TOUR_CONFIG: TourConfig = {
  id: 'returns-tour',
  name: 'Guida all\'Elenco Resi',
  steps: [
    {
      id: 'welcome',
      selector: '.main-title',
      title: '👋 Benvenuto nell\'Elenco Resi',
      content: 'Questa guida ti mostrerà come consultare i resi affidati: filtri, tabella con tutte le sue funzioni, stampe ed esportazioni. Clicca "Avanti" per iniziare il tour.',
      position: 'bottom',
      showNext: true,
      showPrev: false,
      showSkip: true
    },
    {
      id: 'toolbox',
      selector: '.toolbox-container',
      title: '🧰 Strumentario',
      content: 'Gli strumenti rapidi della pagina: <strong>aggiorna i dati</strong> con i filtri correnti, <strong>comprimi/espandi</strong> la sezione filtri e attiva la <strong>vista compatta</strong> della tabella (righe più fitte, utile con molti risultati).',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'filters-section',
      selector: '#filters-section',
      title: '🔍 Filtri e Azioni',
      content: 'Qui filtri i resi per <strong>cliente, marchio, tipologia, dealer, codici, stato corrente, vettore, piattaforma, regione</strong> e puntualità. Il badge "Filtri attivi" ti ricorda quando la ricerca è ristretta.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true,
      beforeShow: () => {
        // Assicurati che la sezione filtri sia aperta
        const component = (window as any).returnsComponent;
        if (component && !component.showFilters) {
          component.toggleFiltersSection();
        }
      }
    },
    {
      id: 'date-filters',
      selector: '#returns-date-filters',
      title: '📅 Filtri Data',
      content: 'I quattro filtri data delimitano <strong>affido</strong> e <strong>consegna</strong> (Da/A). Ogni campo ha il calendario e le frecce di navigazione rapida per spostarsi di un giorno alla volta.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'filter-actions',
      selector: '#returns-filter-actions',
      title: '🚀 Azioni di Ricerca',
      content: 'Usa <strong>"Azzera filtri"</strong> per ripartire da zero e <strong>"Applica filtri"</strong> per eseguire la ricerca. La ricerca è paginata dal server: vedrai sempre il totale aggiornato.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'export-excel',
      selector: '#returns-export-excel',
      title: '📥 Esportazione Excel',
      content: 'Scarica in Excel <strong>tutti i resi filtrati</strong> (non solo la pagina a video), una riga per reso con i dati principali: codici, dealer, date, stato corrente, magazzino, vettore e regione.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'export-excel-details',
      selector: '#returns-export-details',
      title: '📥 Excel con Dettaglio Stati',
      content: 'Questa esportazione aggiunge per ogni reso le colonne dei <strong>5 stati di avanzamento</strong> (data, magazzino e vettore di ciascuno): utile per analisi complete del percorso del reso.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'closure-excel',
      selector: '#returns-closure-excel',
      title: '📤 Excel di Chiusura',
      content: 'Apre il popup per <strong>caricare il file di chiusura</strong> dei resi: il sistema valorizza la data di consegna e chiude i resi elencati nel file, segnalando le righe applicate, scartate o errate.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'columns-dropdown',
      selector: '.toolbox-dropdown-wrapper',
      title: '📊 Colonne Visibili e Ordine',
      content: 'Da questo menu <strong>mostri/nascondi ogni colonna</strong> (compresa Stampa) con le checkbox e la <strong>riordini</strong> con le frecce su/giù. "Ripristina" riporta visibilità e ordine originali. Le preferenze restano salvate sul browser.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true,
      beforeShow: () => {
        // Apri il dropdown così le opzioni sono visibili durante il passo
        const component = (window as any).returnsComponent;
        if (component) {
          component.isColumnsDropdownOpen = true;
        }
      }
    },
    {
      id: 'page-size',
      selector: '.pagination-selector',
      title: '🔢 Elementi per Pagina',
      content: 'Scegli quante righe mostrare per pagina (<strong>5, 10, 25, 50 o 100</strong>). La scelta viene ricordata per le prossime visite. Accanto, il contatore mostra il <strong>totale dei resi filtrati</strong>.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true,
      beforeShow: () => {
        // Chiudi il dropdown colonne aperto dal passo precedente
        const component = (window as any).returnsComponent;
        if (component) {
          component.isColumnsDropdownOpen = false;
        }
      }
    },
    {
      id: 'table-sorting',
      selector: '.rt-table .sortable-th',
      title: '↕️ Ordinamento dei Risultati',
      content: 'Le intestazioni con le <strong>frecce</strong> sono ordinabili: un click ordina in crescendo, un secondo click inverte. L\'ordinamento è applicato dal server su <strong>tutti i resi filtrati</strong>, non solo sulla pagina corrente.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'table-column-drag',
      selector: '.rt-table thead',
      title: '↔️ Riordino Colonne col Trascinamento',
      content: 'Oltre che dal menu colonne, puoi riorganizzare la tabella <strong>trascinando un\'intestazione</strong> e rilasciandola dove preferisci: la colonna di destinazione si evidenzia in azzurro durante il trascinamento.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'row-detail',
      selector: '.rt-row',
      title: '🕓 Timeline degli Stati',
      content: '<strong>Clicca una riga</strong> per aprire la timeline del reso: gli stati da <strong>Pianificato</strong> a <strong>Consegnato</strong> (o Chiuso forzatamente) con data, magazzino e vettore di ogni passaggio. Un triangolo arancione segnala date fuori sequenza. Clicca di nuovo per richiudere.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'cell-copy',
      selector: '.rt-row',
      title: '📎 Copia Rapida del Dato',
      content: 'Passando il mouse su una cella valorizzata compare il <strong>bottone di copia</strong> in fondo al dato: un click copia negli appunti il valore così come lo vedi (una spunta verde conferma la copia).',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'print-column',
      selector: '.rt-print-btn',
      title: '🖨️ Stampa del Reso',
      content: 'Il bottone stampante apre il popup di stampa del reso: da lì generi la <strong>label</strong> da applicare al contenitore e la <strong>bolla</strong> di accompagnamento in PDF.',
      position: 'right',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'pagination',
      selector: '.pagination-container',
      title: '📄 Paginazione',
      content: 'Naviga tra le pagine dei risultati con le frecce o i numeri: la pagina corrente viene ricordata anche quando torni su questa sezione.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'tour-complete',
      selector: '.main-title',
      title: '🎉 Tour Completato!',
      content: 'Perfetto! Ora conosci tutte le funzionalità dell\'<strong>Elenco Resi</strong>. Usa questo tour quando vuoi ripassare le funzionalità. Buon lavoro! 🚀',
      position: 'bottom',
      showNext: false,
      showPrev: true,
      showSkip: false
    }
  ]
};
